import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addTenantFeature } from '../../api/queries';

export const useAddTenantFeatureMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      tenantId,
      feature,
    }: {
      tenantId: number;
      feature: string;
    }) => addTenantFeature(tenantId, feature),
    onSuccess: (_, variables) => {
      // Invalidate and refetch tenant features
      queryClient.invalidateQueries({
        queryKey: ['GET_TENANT_FEATURES', variables.tenantId],
      });
    },
  });
};
